import React, { useState } from "react";
import "./App.css";

// 質問データ
const questions = [
{text: "あなたの肌の印象に近いのはどれですか？",
  options: [
    { text: "明るく透明感がある", type: "ブルベ夏", colors: ["#fce8e6", "#f7dede"] },
    { text: "血色感が強い", type: "イエベ春", colors: ["#ffe3c4", "#ffd4a8"] },
    { text: "落ち着いたオークル系", type: "イエベ秋", colors: ["#d9b38c", "#b98b5d"] },
    { text: "白くコントラストがはっきり", type: "ブルベ冬", colors: ["#f9ecec", "#f6e6e6"]}
  ]
},

  { text: "日焼けするとどうなりますか？", options: [
    { text: "赤くなってすぐ冷める", type: "ブルベ夏" },
    { text: "すぐ小麦色に焼ける", type: "イエベ春" },
    { text: "焼けるとすぐに茶色になる", type: "イエベ秋" },
    { text: "赤黒くなりやすい", type: "ブルベ冬" },
  ]},

{ text: "アクセサリーでよく身につけるものは？", options: [
    { text: "シルバーが多い", 
      type: "ブルベ夏", 
      colors: ["#b0b0b0", "#d9d9d9"] // 少し青みのあるシルバーグレー 
    },
    { text: "ゴールドが多い", 
      type: "イエベ春", 
      colors: ["#ffd966", "#f4c542"] // 明るく黄みの強いゴールド 
    },
    { text: "アンティークゴールドが多い", 
      type: "イエベ秋", 
      colors: ["#a67c52", "#8c6239"] // 深みのあるアンティーク系ゴールド 
    },
    { text: "プラチナやホワイトゴールドが多い", 
      type: "ブルベ冬", 
      colors: ["#e6e6e6", "#cccccc"] // 白っぽいプラチナカラー 
    }
  ]
},

  {text: "似合うリップの色は？またはよく使う色はどれ？",
  options: [
    { text: "ローズピンク", type: "ブルベ夏", colors: ["#f4a3b5", "#e17b9c"] },
    { text: "コーラルピンク", type: "イエベ春", colors: ["#ffb3b3", "#ff7f7f"] },
    { text: "テラコッタ", type: "イエベ秋", colors: ["#d2694c", "#b35430"] },
    { text: "ボルドー", type: "ブルベ冬", colors: ["#8b1a2b", "#5a0a1b"] }
  ]
},


  { text: "第一印象でよく言われるのは？", options: [
    { text: "柔らかく優しい", type: "ブルベ夏" },
    { text: "明るく元気", type: "イエベ春" },
    { text: "落ち着いて大人っぽい", type: "イエベ秋" },
    { text: "クールで洗練されている", type: "ブルベ冬" },
  ]},

{ text: "好き、またはよくする髪色は？（似合うと思う色でもOK）", 
  options: [
    { text: "アッシュブラウン", type: "ブルベ夏", colors: ["#6b4f4f", "#9c7d7d"] }, 
    { text: "オレンジブラウン", type: "イエベ春", colors: ["#8b4513", "#c07a45"] }, 
    { text: "ダークブラウン", type: "イエベ秋", colors: ["#2f1f1f","#4b3832"] }, 
    { text: "ブラック", type: "ブルベ冬", colors: ["#1a1a1a", "#333333"] },
    { text: "ピンク系（ローズ・チェリーピンクなど）", type: "ブルベ夏", colors: ["#b45c74", "#c96f82"] }, 
    { text: "ベージュ系（ミルクティー・ライトベージュなど）", type: "イエベ春", colors: ["#c9a87c","#e6d1b5"] }
  ]},

  { text: "よく着る、または好きな服の色は？", options: [
    { text: "ラベンダーやブルー系", 
      type: "ブルベ夏", 
      colors: ["#b19cd9", "#9bb7d4", "#a7c7e7"] 
    },
    { text: "イエローやコーラル系", 
      type: "イエベ春", 
      colors: ["#ffcc70", "#ffb347", "#ff7f7f"] 
    },
    { text: "カーキやモカブラウン系", 
      type: "イエベ秋", 
      colors: ["#6b8e23", "#a67b5b", "#8b5e3c"] 
    },
    { text: "モノトーンやビビッドカラー", 
      type: "ブルベ冬", 
      colors: ["#111111", "#444444", "#d2042d"] 
    },
    { text: "ベージュやアイボリー系", 
      type: "イエベ春/秋", 
      colors: ["#f5f5dc", "#f0e6d2", "#e6d5b8"] 
    },
    { text: "ホワイトやオフホワイト系", 
      type: "ブルベ夏/冬", 
      colors: ["#ffffff", "#f5f5f5", "#eaeaea"] 
    }
  ] 
},

  { text: "瞳の色に近いのは？", options: [
    { text: "ソフトブラウン", type: "ブルベ夏", color: "#7b5e57" },
    { text: "ライトブラウン", type: "イエベ春", color: "#c68642" },
    { text: "ダークブラウン", type: "イエベ秋", color: "#3d2b1f" },
    { text: "黒に近いダークカラー", type: "ブルベ冬", color: "#0a0a0a" },
  ]},
];

// タイプごとのデータ（コスメをリップ/アイシャドウ/チークで分類）
const resultsData = {
  "ブルベ夏": {
    description: "ソフトで優しい色が似合います。ローズピンクやラベンダー系がおすすめ。",
    palette: [
      "#f2a7c1", "#c182b8", "#7ea1d6", "#5c77b3",
      "#e3b7d3", "#a8c5f0", "#cdb4db", "#bde0fe",
    ],
    cosmetics: {
      lip: [
        { brand: "Dior", name: "アディクト リップグロウ 006 ベリー", price: "4,620円" },
        { brand: "CEZANNE", name: "ラスティンググロスリップ PK11", price: "660円" },
      ],
      eyeshadow: [
        { brand: "SUQQU", name: "シグニチャーカラーアイズ 04 純撫子", price: "7,700円" },
        { brand: "CANMAKE", name: "シルキースフレアイズ 06 トパーズピンク", price: "825円" },
      ],
      cheek: [
        { brand: "JILL STUART", name: "ブルーム ミックスブラッシュ 15", price: "4,620円" },
        { brand: "ちふれ", name: "パウダーチーク 270 ローズ系", price: "506円" },
      ],
    },
  },
  "イエベ春": {
    description: "明るくて元気な色が似合います。コーラルやオレンジ系がおすすめ。",
    palette: [
      "#f8b195", "#f67280", "#fbc687", "#ffda77",
      "#ffd6a5", "#ffb5a7", "#ffc8dd", "#ffe5b4",
    ],
    cosmetics: {
      lip: [
        { brand: "OPERA", name: "リップティント 05 コーラルピンク", price: "1,650円" },
        { brand: "YSL", name: "ルージュ ヴォリュプテ シャイン 15", price: "5,500円" },
      ],
      eyeshadow: [
        { brand: "ETUDE", name: "プレイカラーアイズ ピーチファーム", price: "2,750円" },
        { brand: "excel", name: "リアルクローズシャドウ CS01", price: "1,650円" },
      ],
      cheek: [
        { brand: "CHANEL", name: "ジュ コントゥラスト 55", price: "7,590円" },
        { brand: "CANMAKE", name: "グロウフルールチークス 10", price: "880円" },
      ],
    },
  },
  "ブルベ冬": {
    description: "クールで鮮やかな色が似合います。青みピンクやボルドー系がおすすめ。",
    palette: [
      "#d291bc", "#957dad", "#6d5b97", "#4d2c91",
      "#ff5d8f", "#b5179e", "#7209b7", "#560bad",
    ],
    cosmetics: {
      lip: [
        { brand: "MAC", name: "リップスティック ルビーウー", price: "3,960円" },
        { brand: "REVLON", name: "スーパーラストラス リップスティック 725", price: "1,320円" },
      ],
      eyeshadow: [
        { brand: "NARS", name: "シングルアイシャドー 2046", price: "3,520円" },
        { brand: "KATE", name: "クラッシュダイヤモンドアイズ BK-1", price: "1,320円" },
      ],
      cheek: [
        { brand: "RMK", name: "カラー パフォーマンスチーク 03", price: "3,630円" },
        { brand: "CEZANNE", name: "ナチュラルチークN 18 ローズベージュ", price: "396円" },
      ],
    },
  },
  "イエベ秋": {
    description: "落ち着いた深みのある色が似合います。ブラウンやテラコッタ系がおすすめ。",
    palette: [
      "#d4a373", "#bc6c25", "#99582a", "#6c584c",
      "#e07a5f", "#b5651d", "#8c5e31", "#5a3d2b",
    ],
    cosmetics: {
      lip: [
        { brand: "RMK", name: "リクイドリップカラー 06 テラコッタ", price: "4,180円" },
        { brand: "KATE", name: "リップモンスター 05 ダークフィグ", price: "1,540円" },
      ],
      eyeshadow: [
        { brand: "Celvoke", name: "ヴォランタリーアイズ 29 オレンジブラウン", price: "2,200円" },
        { brand: "CLIO", name: "プロアイパレット 02 ブラウンシュー", price: "3,740円" },
      ],
      cheek: [
        { brand: "LAURA MERCIER", name: "ブラッシュ カラー インフュージョン チャイ", price: "4,730円" },
        { brand: "ちふれ", name: "パウダーチーク 443 ブラウン系", price: "506円" },
      ],
    },
  },
};

// 中間タイプ専用カラー & コスメ
const hybridPalettes = {
  "ブルベ夏×ブルベ冬": [
    "#e0c3fc", "#caa6e8", "#9c7ed3", "#5c6bc0", "#3949ab", "#283593"],
  "ブルベ冬×ブルベ夏": [
    "#e0c3fc", "#caa6e8", "#9c7ed3", "#5c6bc0", "#3949ab", "#283593"],
  "イエベ春×イエベ秋": [
    "#ffe0b2", "#f7c59f", "#ed9b40", "#d2601a", "#9a3412", "#6d2815"],
  "イエベ秋×イエベ春": [
    "#ffe0b2", "#f7c59f", "#ed9b40", "#d2601a", "#9a3412", "#6d2815"],
  "ブルベ冬×イエベ春": [
    "#f48fb1", "#ec407a", "#f06292", "#ffb74d", "#fdd835", "#f9a825"],
  "イエベ春×ブルベ冬": [
    "#f48fb1", "#ec407a", "#f06292", "#ffb74d", "#fdd835", "#f9a825"],
  "ブルベ夏×イエベ秋": [
    "#d1c4e9", "#a5a6f6", "#7e5a9b", "#b77966", "#874c62", "#5d3a42"],
  "イエベ秋×ブルベ夏": [
    "#d1c4e9", "#a5a6f6", "#7e5a9b", "#b77966", "#874c62", "#5d3a42"],
  "ブルベ夏×イエベ春": [
    "#ffb3ba", "#ffdfba", "#bae1ff", "#caffbf", "#ffd6e0", "#d7e3fc"],
  "イエベ春×ブルベ夏": [
    "#ffb3ba", "#ffdfba", "#bae1ff", "#caffbf", "#ffd6e0", "#d7e3fc"],
  "ブルベ冬×イエベ秋": [
    "#ff8a65", "#ff7043", "#8d6e63", "#3949ab", "#6d4c41", "#311b92"],
  "イエベ秋×ブルベ冬": [
    "#ff8a65", "#ff7043", "#8d6e63", "#3949ab", "#6d4c41", "#311b92"],
};

const hybridRecommendations = {
  "ブルベ冬×ブルベ夏": [
    { brand: "SUQQU", name: "シグニチャーカラーアイズ 02 陽香色", price: "¥7,700" },
    { brand: "Dior", name: "ディオール アディクト リップスティック 525", price: "¥5,500" },
    { brand: "CANMAKE", name: "パーフェクトスタイリストアイズ 23", price: "¥858" },
    { brand: "YSL", name: "ルージュ ヴォリュプテ シャイン 122", price: "¥5,500" },
    { brand: "NARS", name: "ブラッシュ 4069", price: "¥4,070" },
    { brand: "ETUDE", name: "プレイカラー アイシャドウ ワインパーティー", price: "¥2,750" }
  ],

"ブルベ夏×ブルベ冬": [
    { brand: "SUQQU", name: "シグニチャーカラーアイズ 02 陽香色", price: "¥7,700" },
    { brand: "Dior", name: "ディオール アディクト リップスティック 525", price: "¥5,500" },
    { brand: "CANMAKE", name: "パーフェクトスタイリストアイズ 23", price: "¥858" },
    { brand: "YSL", name: "ルージュ ヴォリュプテ シャイン 122", price: "¥5,500" },
    { brand: "NARS", name: "ブラッシュ 4069", price: "¥4,070" },
    { brand: "ETUDE", name: "プレイカラー アイシャドウ ワインパーティー", price: "¥2,750" }
  ],

  "イエベ春×イエベ秋": [
    { brand: "Celvoke", name: "エンスロール グロス 05", price: "¥3,520" },
    { brand: "RMK", name: "インジーニアス パウダーアイズ N 15", price: "¥2,750" },
    { brand: "Visee", name: "リシェ フォギーオンチークスN PK820", price: "¥1,650" },
    { brand: "CHANEL", name: "ルージュ ココ フラッシュ 90 ジュール", price: "¥5,500" },
    { brand: "JILL STUART", name: "ブルーム ミックスブラッシュ コンパクト 15", price: "¥4,620" },
    { brand: "rom&nd", name: "ジューシーラスティングティント 13 イートドトリ", price: "¥1,320" }
  ],

    "イエベ秋×イエベ春": [
    { brand: "Celvoke", name: "エンスロール グロス 05", price: "¥3,520" },
    { brand: "RMK", name: "インジーニアス パウダーアイズ N 15", price: "¥2,750" },
    { brand: "Visee", name: "リシェ フォギーオンチークスN PK820", price: "¥1,650" },
    { brand: "CHANEL", name: "ルージュ ココ フラッシュ 90 ジュール", price: "¥5,500" },
    { brand: "JILL STUART", name: "ブルーム ミックスブラッシュ コンパクト 15", price: "¥4,620" },
    { brand: "rom&nd", name: "ジューシーラスティングティント 13 イートドトリ", price: "¥1,320" }
  ],

  "ブルベ夏×イエベ春": [
    { brand: "Dior", name: "サンク クルール クチュール 659", price: "¥9,570" },
    { brand: "CHANEL", name: "ルージュ アリュール インク 144", price: "¥5,500" },
    { brand: "CEZANNE", name: "ナチュラルチークN 14", price: "¥396" },
    { brand: "ETUDE", name: "プレイカラー アイシャドウ ピーチファーム", price: "¥2,750" },
    { brand: "YSL", name: "ルージュ ピュールクチュール 13", price: "¥5,500" },
    { brand: "rom&nd", name: "ベターザンチーク 04 フィグチップ", price: "¥1,100" }
  ],

  "ブルベ夏×イエベ秋": [
    { brand: "NARS", name: "クワッドアイシャドー 3972", price: "¥6,820" },
    { brand: "MAC", name: "リップスティック シーシアー", price: "¥3,630" },
    { brand: "INTEGRATE", name: "プロフィニッシュチーク PK322", price: "¥1,320" },
    { brand: "CHANEL", name: "レ ベージュ パレット ルガール ウォーム", price: "¥8,800" },
    { brand: "LUNASOL", name: "プランプメロウリップス EX08", price: "¥4,400" },
    { brand: "CANMAKE", name: "グロウフルールチークス 11", price: "¥880" }
  ],

  "ブルベ冬×イエベ春": [
    { brand: "CHANEL", name: "レ キャトル オンブル 354", price: "¥8,360" },
    { brand: "YSL", name: "ルージュ ヴォリュプテ キャンディグレーズ 2", price: "¥5,500" },
    { brand: "CANMAKE", name: "シルキースフレアイズ 10", price: "¥825" },
    { brand: "ADDICTION", name: "ザ ブラッシュ 011", price: "¥3,630" },
    { brand: "rom&nd", name: "ジューシーラスティングティント 25 ベアグレープ", price: "¥1,320" },
    { brand: "ETUDE", name: "ルックアット マイアイズ RD302", price: "¥550" }
  ],

  "ブルベ冬×イエベ秋": [
    { brand: "SUQQU", name: "トーン タッチ アイズ 18", price: "¥4,070" },
    { brand: "Dior", name: "ルージュ ディオール 772", price: "¥5,500" },
    { brand: "CEZANNE", name: "ラスティンググロスリップ 101", price: "¥528" },
    { brand: "BOBBI BROWN", name: "シアーリップスティック 19", price: "¥4,950" },
    { brand: "CANMAKE", name: "グロウフルールチークス 12", price: "¥880" },
    { brand: "rom&nd", name: "ベターザンパレット 02 マホガニーガーデン", price: "¥2,750" }
  ]
};

// ブルベ or イエベ 判定用
const toneMap = {
  "ブルベ夏": "ブルベ",
  "ブルベ冬": "ブルベ",
  "イエベ春": "イエベ",
  "イエベ秋": "イエベ",
};

function App() {
  const [answers, setAnswers] = useState([]);
  const [result, setResult] = useState(null);

  const handleAnswer = (answer) => {
    const newAnswers = [...answers, answer.type];
    setAnswers(newAnswers);

    if (newAnswers.length === questions.length) {
      const scores = {};
      newAnswers.forEach((a) => {
        scores[a] = (scores[a] || 0) + 1;
      });

      const sorted = Object.entries(scores).sort((a, b) => b[1] - a[1]);
      const [first, second] = sorted;

      let finalResult = {};
      if (second && first[1] - second[1] <= 2) {
        const primaryTone = toneMap[first[0]];
        const secondaryTone = toneMap[second[0]];
        const tendency =
          primaryTone === secondaryTone ? `${primaryTone}寄り` : "ニュートラル";
        finalResult = {
          primary: first[0],
          secondary: second[0],
          isHybrid: true,
          tendency,
        };
      } else {
        finalResult = { primary: first[0], isHybrid: false };
      }

      setResult(finalResult);
    }
  };

const renderCosmetics = (cosmetics) => (
  <>
    <h4>💄 リップ</h4>
    <div className="cosmetics-container">
      {cosmetics.lip.map((item, i) => (
        <div key={i} className="card">
          <p><strong>{item.brand}</strong></p>
          <p>{item.name}</p>
          <p>{item.price}</p>
          <a
            href={`https://www.google.com/search?q=${encodeURIComponent(item.brand + " " + item.name)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="search-link"
          >
            🔍 このコスメをGoogleで検索
          </a>
        </div>
      ))}
    </div>

    <h4>👁 アイシャドウ</h4>
    <div className="cosmetics-container">
      {cosmetics.eyeshadow.map((item, i) => (
        <div key={i} className="card">
          <p><strong>{item.brand}</strong></p>
          <p>{item.name}</p>
          <p>{item.price}</p>
          <a
            href={`https://www.google.com/search?q=${encodeURIComponent(item.brand + " " + item.name)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="search-link"
          >
            🔍 このコスメをGoogleで検索
          </a>
        </div>
      ))}
    </div>

    <h4>🌸 チーク</h4>
    <div className="cosmetics-container">
      {cosmetics.cheek.map((item, i) => (
        <div key={i} className="card">
          <p><strong>{item.brand}</strong></p>
          <p>{item.name}</p>
          <p>{item.price}</p>
          <a
            href={`https://www.google.com/search?q=${encodeURIComponent(item.brand + " " + item.name)}`}
            target="_blank"
            rel="noopener noreferrer"
            className="search-link"
          >
            🔍 このコスメをGoogleで検索
          </a>
        </div>
      ))}
    </div>
  </>
);

  return (
    <div className="App">
      <h1>パーソナルカラー診断</h1>

      {!result ? (
        <div>
          <p>質問に答えてください（{answers.length + 1}/{questions.length}）</p>
          <p>{questions[answers.length].text}</p>
         <div className="options-container">
  {questions[answers.length].options.map((opt, i) => (
    <div key={i} className="option-with-palette">
      <button 
        onClick={() => handleAnswer(opt)}
        className="option-btn"
      >
        {opt.text}
      </button>
      
      {/* パレットを選択肢ごとに表示 */}
      { (opt.colors || (opt.color ? [opt.color] : []))?.length > 0 && (
        <div className="palette">
          {(opt.colors || [opt.color]).map((c, j) => (
            <span
              key={j}
              className="color-circle"
              style={{ backgroundColor: c }}
            ></span>
          ))}
        </div>
      )}
    </div>
  ))}
</div>




          
        </div>
      ) : (
        <div>
          {result.isHybrid ? (
            <>
              <h2>{result.primary} × {result.secondary} タイプ</h2>
              <p>傾向: {result.tendency}</p>

              {/* primary の詳細 */}
              <h3>{result.primary} タイプの特徴</h3>
              <p>{resultsData[result.primary].description}</p>
              <div className="palette">
                {resultsData[result.primary].palette.map((color, index) => (
                  <div key={index} className="color-circle" style={{ backgroundColor: color }}></div>
                ))}
              </div>
              {renderCosmetics(resultsData[result.primary].cosmetics)}

              {/* secondary の詳細 */}
              <h3>{result.secondary} タイプの特徴</h3>
              <p>{resultsData[result.secondary].description}</p>
              <div className="palette">
                {resultsData[result.secondary].palette.map((color, index) => (
                  <div key={index} className="color-circle" style={{ backgroundColor: color }}></div>
                ))}
              </div>
              {renderCosmetics(resultsData[result.secondary].cosmetics)}

             {/* ハイブリッド専用 */}
<h3>{result.primary} × {result.secondary} ミックスさんにおすすめカラー</h3>
<div className="palette">
  {(hybridPalettes[`${result.primary}×${result.secondary}`] || []).map((color, index) => (
    <div key={index} className="color-circle" style={{ backgroundColor: color }}></div>
  ))}
</div>

<h3>{result.primary} × {result.secondary} ミックスさんにおすすめコスメ</h3>
<div className="cosmetics-container">
  {(hybridRecommendations[`${result.primary}×${result.secondary}`] || []).map((item, i) => (
    <div key={i} className="card hybrid">
      <p><strong>{item.brand}</strong></p>
      <p>{item.name}</p>
      <p>{item.price}</p>
      <a
        href={`https://www.google.com/search?q=${encodeURIComponent(item.brand + " " + item.name)}`}
        target="_blank"
        rel="noopener noreferrer"
        className="search-link"
      >
        🔍 このコスメをGoogleで検索
      </a>
    </div>
  ))}
</div>


            </>
          ) : (
            <>
              <h2>{result.primary} タイプ</h2>
              <p>{resultsData[result.primary].description}</p>
              <div className="palette">
                {resultsData[result.primary].palette.map((color, index) => (
                  <div key={index} className="color-circle" style={{ backgroundColor: color }}></div>
                ))}
              </div>

              {renderCosmetics(resultsData[result.primary].cosmetics)}
            </>
          )}
          <button onClick={() => { setAnswers([]); setResult(null); }}>
            もう一度診断する
          </button>
        </div>
      )}
    </div>
  );
}

export default App;
